import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";

function VoiceOfCustomer() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  return (
    <div>
      <div className="section-1">
        <div className="relative-1">
          <div className="s1-heading-text">
            <h1 data-aos="zoom-in">Engineering Earth’s Comeback</h1>
            <p data-aos="zoom-in">
              Welcome to Accel1 — India’s first Climate Engineering Super
              Platform for regenerative industry, carbon removal, and
              planetary-scale solutions.
            </p>
            <a href="#" className="button-1 green-bg">
              Explore Our Mission
            </a>
            <a href="#" className="button-1">
              Partner With Us
            </a>
          </div>
          <img src={assets.banner1} alt="" data-aos="fade-in" />
        </div>
      </div>
    </div>
  );
}

export default VoiceOfCustomer;
